/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { array, func } from 'prop-types';

import p from 'polyglot/polyglot';

import Button from 'components/Button/Button';
import Title from 'components/Title/Title';
import styles from './add-roles.scss';

/**
 * This is the AddRoles component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class AddRoles extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    roles: array.isRequired,
    addRole: func.isRequired,
  };

  renderButtons() {
    const { roles, addRole } = this.props;

    return roles
      .filter(({ active }) => !active)
      .map(({ type }) => (
        <li key={type.toLowerCase()}>
          <Button ghost dark onClick={() => addRole(type)} wide>
            {p.t(`account.admin.add_roles.types.${type.toLowerCase()}`)}
          </Button>
        </li>
      ));
  }

  /**
   * Render AddRoles.
   *
   * @return {Object}
   */
  render() {
    return (
      <article className={styles.wrapper}>
        <Title
          large
          className={styles.title}
          title={p.t('account.admin.add_roles.title')}
        />

        <ul className={styles.buttons}>{this.renderButtons()}</ul>
      </article>
    );
  }
}
